import { fromJS } from "immutable";
import { barcodeQtyImportActions } from "actions/barcodeQtyImportActions.js";

const initialState = fromJS({
  hasErrors: false,
  isUploadSuccesful: false,
  data: {
    presignedUrl: null
  }
});

export default (state = initialState, action) => {
  const payload = action.payload;

  switch (action.type) {
    case barcodeQtyImportActions.fileUploadUrlSuccess:
      return state
        .merge({
          hasErrors: false
        })
        .set("data", fromJS(payload.data));
    case barcodeQtyImportActions.fileUploadUrlFailure:
      return state
        .merge({
          hasErrors: true
        })
    case barcodeQtyImportActions.buyplanBarcodeQtyImportSuccess:
      return state
        .merge({
          isUploadSuccesful: true
        })    
    default:
      return state;
  }
};

